import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { navItems } from "../../assets/data/navbar";
import CustomToggle from "../ui/CustomToggle";
import logo from "../../assets/images/logo.png";
import { UserAuth } from "../../lib/authContext";

const NavigationBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = UserAuth();

  const navbarItems = user
    ? navItems
    : [
        { name: "Home", link: "" },
        { name: "Contact Us", link: "contact_us" },
      ];

  const [currentNav, setCurrentNav] = useState("");
  const [isTogglerOpen, setTogglerOpen] = useState(false);

  const handleTogglerClick = () => {
    setTogglerOpen(!isTogglerOpen);
  };

  useEffect(() => {
    const path = location.pathname.split("/")[1];
    setCurrentNav(path);
  }, [location]);

  return (
    <div className="w-full">
      <nav
        id="NavMain"
        className="bg-white px-3 py-4 sm:px-4 fixed top-0 w-full z-50 rounded-none shadow-md"
      >
        <div className="container mx-auto flex md:flex-wrap items-center justify-between">
          <a
            href="/"
            className="flex items-center mx-2"
            onClick={() => {
              navigate(`/`);
              setCurrentNav("home");
              const elementToView = document.getElementById("home");
              elementToView?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            <img
              src={logo}
              className="mr-2 md:mr-3 h-10 cursor-pointer rounded-md"
              alt="Clienthub"
            />
            <p className="uppercase">Clienthub</p>
          </a>

          <div className="hidden lg:flex items-center space-x-8">
            {navbarItems.map((item, index) => (
              <div key={index} className="relative">
                <a
                  href={`/${item.link}`}
                  onClick={() => setCurrentNav(item.link)}
                  className={`flex items-center md:hover:!text-[gold] text-lg font-medium transition-colors ease-in-out duration-300 ${
                    currentNav === item.link ? "!text-gold" : "!text-black"
                  }`}
                >
                  {item.name}
                </a>
              </div>
            ))}
          </div>

          <div className="flex lg:hidden items-center space-x-4">
            {/* Custom toggle button */}
            <CustomToggle isOpen={isTogglerOpen} onClick={handleTogglerClick} />
          </div>
        </div>

        {/* Mobile Menu */}
        {isTogglerOpen && (
          <div className="block lg:hidden pt-5">
            {navbarItems.map((item, index) => (
              <div
                key={index}
                className={`${
                  navItems.length === index + 1 ? "" : "border-b"
                } flex flex-col items-center`}
              >
                <div className="flex flex-row justify-between w-full p-2">
                  <a
                    href={`/${item.link}`}
                    onClick={() => setCurrentNav(item.link)}
                    className={`font-medium cursor-pointer md:hover:!text-[gold] transition-colors ease-in-out duration-300 ${
                      currentNav === item.link ? "!text-gold" : "!text-black"
                    }`}
                  >
                    {item.name}
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </nav>
    </div>
  );
};

export default NavigationBar;
